module.exports = __webpack_public_path__ + "img/arrow-up.bf8883ea.svg";